module.exports = __webpack_public_path__ + "img/school_3.f2795a0.jpg";